import { Formik } from "formik";
import { Fragment, useEffect, useState } from "react";
import { styled } from "@mui/system";
import { useDispatch } from "react-redux";
import { Grid, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import FormDisplay from "./FormDisplay";
import { useAlert, useAxios } from "../../hooks";
import {
  formDisplayValidationSchema,
  objectFromFormData,
  objectFromResponseData,
  signUpDetailsObject,
} from "./signUpDetailsObject";

const FormBox = styled(Paper)`
  width: 100%;
  padding: 20px;
  border-radius: 7.5px;
  background: rgba(255, 255, 255, 0.5);
`;

export default function SignUp() {
  const axios = useAxios({ baseURL: "mox_api_2", disableAuthToken: true });
  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const agentId = queryParams.get("agent_id");

  const [formData, setFormData] = useState(signUpDetailsObject);

  useEffect(() => {
    axios({ url: "/event/agent?agent_id=" + agentId }).then((response) => {
      if (response.status) {
        setFormData(objectFromResponseData(response.data));
      }
    });
  }, []);

  return (
    <Fragment>
      <Grid container justifyContent={"center"}>
        <Grid item xs={11}>
          <FormBox>
            <Formik
              enableReinitialize
              initialValues={formData}
              validationSchema={formDisplayValidationSchema}
              validateOnMount
              onSubmit={async (formData, { setSubmitting }) => {
                try {
                  const res = await axios({
                    url: "/event/agent/sign-up",
                    method: "POST",
                    data: objectFromFormData(formData),
                    disableRedirect: true,
                  });
                  if (res.status) {
                    dispatch(alert({ message: "Welcome!", type: "success" }));
                    navigate("/sign-in");
                  }
                } catch (error) {
                  console.error("Login error:", error);
                } finally {
                  setSubmitting(false);
                }
              }}
            >
              {(formikProps) => (
                <form onSubmit={formikProps.handleSubmit}>
                  <FormDisplay formikProps={formikProps} />
                </form>
              )}
            </Formik>
          </FormBox>
        </Grid>
      </Grid>
    </Fragment>
  );
}
